/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { useState } from 'react';
import { WidgetProps } from '@rjsf/utils';
import { Slider } from 'primereact/slider';
import { InputText } from 'primereact/inputtext';
import styled from 'styled-components';
import { Button } from 'primereact/button';

const CInputText = styled(InputText)`
  border-radius: 0;
  height: 32px;
  border-color: #000;
`;
export const SliderWidget: React.FC<WidgetProps> = (props) => {
  const { value, schema } = props;

  const showValue = value ?? schema.default ?? 0;
  const [isSliderVisible, setIsSliderVisible] = useState(schema.minOccurs !== 0);

  return (
    <div className="w-full flex flex-column">
      <div className="flex w-full align-items-center justify-content-between mb-3">
        {schema.minOccurs === 0 &&
          (isSliderVisible ? (
            <Button
              style={{ borderRadius: 0, height: 30, width: 30 }}
              onClick={() => {
                props.onChange(undefined);
                setIsSliderVisible(false);
              }}
              type="button"
              size="small"
              outlined
              icon="pi pi-trash"
              severity="contrast"
            />
          ) : (
            <Button
              style={{ borderRadius: 0, height: 30, width: 30 }}
              onClick={() => {
                props.onChange(0);
                setIsSliderVisible(true);
              }}
              type="button"
              size="small"
              outlined
              icon="pi pi-plus"
              severity="contrast"
            />
          ))}
      </div>
      {schema.minOccurs !== 0 ? (
        <div className={'mt-0 mb-2 w-full'}>
          <CInputText
            type="number"
            value={showValue}
            min={schema.minimum ?? 0}
            max={schema.maximum ?? 100}
            onChange={(e) => props.onChange(e.target.value)}
            className="w-full"
          />
          <Slider
            value={showValue}
            min={schema.minimum ?? 0}
            max={schema.maximum ?? 100}
            onChange={(e) => {
              props.onChange(e.value);
            }}
            className="w-full mt-2"
          />
        </div>
      ) : (
        isSliderVisible && (
          <div className={'mt-0 mb-2 w-full'}>
            <CInputText
              type="number"
              value={showValue}
              min={schema.minimum ?? 0}
              max={schema.maximum ?? 100}
              onChange={(e) => props.onChange(e.target.value)}
              className="w-full"
            />
            <Slider
              value={showValue}
              min={schema.minimum ?? 0}
              max={schema.maximum ?? 100}
              onChange={(e) => {
                props.onChange(e.value);
              }}
              className="w-full mt-2"
            />
          </div>
        )
      )}
    </div>
  );
};
